import { post, get, patch, deleteRequest } from './restApi';

export const getServiceRevenueReport = (payload) => {
    return patch('serviceRevenueReport/get-service-revenue-report', { ...payload });
}
